export default __webpack_public_path__ + "static/media/skills2.574c59c6.png";